import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Plus } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

import { ContactsList } from './components';
import { Button, InternalPage, Spacer, HomeLink } from 'theSource/components';
import { Contacts } from '../types';
import { ButtonWrapperStyled } from './MyContactsViewPageStyled';

export interface MyContactsViewPageProps {
  data: Contacts;
}

export const MyContactsViewPage = ({ data }: MyContactsViewPageProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation('pages.contacts');

  const handleAddNewContact = () => navigate('new');

  return (
    <InternalPage
      description={t('contactsDescription')}
      testId="contacts-view-page"
      title={t('contacts')}
      isLoading={!data}
      CustomActionComponent={<HomeLink />}
      customActionAlignment="left"
    >
      <Spacer height={3} />
      <Stack spacing={8}>
        <ContactsList
          content={
            <Typography variant="body1">
              {t('employerContactsDescription')}
            </Typography>
          }
          contacts={data.employerContacts}
          name={t('employerContacts')}
          testId="employer-contacts-list"
        />
        <ContactsList
          content={
            <ButtonWrapperStyled>
              <Button
                data-testid="add-new-contact-button"
                startIcon={<Plus size={16} weight="bold" />}
                label={t('addContactButtonLabel')}
                variant="tertiary"
                onClick={handleAddNewContact}
              />
            </ButtonWrapperStyled>
          }
          name={t('myContacts')}
          testId="my-contacts-list"
          contacts={data.userContacts}
          displayEmptyListMessage
        />
      </Stack>
    </InternalPage>
  );
};
